import { ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { App } from 'src/app/app';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NgForOf, NgIf } from '@angular/common';
import { ModelService } from "../../service/model.service";
import { IModel_P } from '../../interfaces/IModel';
import { MainCategoriesService } from "../../service/main-categories.service";
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { LoadBrands } from 'src/app/service/load-brands.service';
import { filter, Subject, takeUntil } from 'rxjs';
import { IQueryFormat } from '../../enums/types';
import { ISubCategories, ISubCategories_P, ISubCategories_S } from '../../interfaces/ISubCategories';
import { IMainCategories } from '../../interfaces/IMainCategories';
import { SubCategoriesService } from '../../service/sub-categories.service';
import { SelectedBrandModelService } from '../../service/selected-brand-model.service';

@Component({
    selector: 'app-selection-page',
    imports: [ ReactiveFormsModule, NgForOf, NgIf ],
    templateUrl: './selection-page.html',
    standalone: true,
    styleUrl: './selection-page.scss'
})
export class SelectionPage implements OnInit, OnDestroy {
    selectionForm!: FormGroup;
    loading: boolean = false;
    groupByBrandData: any;
    brands: IBrandsOptions[] = [];
    models: IModelOptions[] = [];
    mainCategoryName: string = '';
    mainCategory: IMainCategories = <any>{};
    subCategories: ISubCategories[] = [];
    mainCategoryId: string = '';
    brandId: string = '';
    modelId: string = '';
    modelName: string = '';
    subCategoryId: string = '';
    categoryName: string = '';
    fileTopImageUrl = 'assets/website-images/brand_model.png';
    selectedBrand: any;
    selectedModel: any;
    brandAccordionOpen: boolean = true;
    modelAccordionOpen: boolean = false;

    @HostListener('window:scroll', [])
    onWindowScroll() {
        this.app.isScrolled = window.scrollY < 99999;
        this.app.hideTopStrip = window.scrollY < 99999;
    }

    private destroy$ = new Subject<void>();

    constructor(private app: App,
                private fb: FormBuilder,
                private modelService: ModelService,
                private subCategoriesService: SubCategoriesService,
                private cdr: ChangeDetectorRef,
                private mainCategoriesService: MainCategoriesService,
                private router: Router,
                private cd: ChangeDetectorRef,
                private route: ActivatedRoute,
                private loadBrandService: LoadBrands,
                private selectedBrandModelService: SelectedBrandModelService) {
    }

    async ngOnInit() {
        this.app.isScrolled = true;
        this.app.hideTopStrip = true;

        this.selectionForm = this.fb.group({
            "selectedBrand": [ '' ],
            "selectedModel": [ '' ],
        });
        await this.getMainCategory();

        this.router.events.pipe(filter(event => event instanceof NavigationEnd), takeUntil(this.destroy$)).subscribe(() => {
            this.mainCategoryId = <any>this.route.snapshot.queryParamMap.get('mainCategoryId');
            this.subCategoryId = <any>this.route.snapshot.queryParamMap.get('subCategoryId');
            this.categoryName = <any>this.route.snapshot.queryParamMap.get('categoryName');
            this.brandId = <any>this.route.snapshot.queryParamMap.get('brandId');
            this.modelId = <any>this.route.snapshot.queryParamMap.get('modelId');
            this.modelName = <any>this.route.snapshot.queryParamMap.get('modelName');
            this.getMainCategory().then();
            this.cd.detectChanges();
        });

        this.mainCategoryName = <any>this.route.snapshot.queryParamMap.get('mainCategoryName');
        this.mainCategoryId = <any>this.route.snapshot.queryParamMap.get('mainCategoryId');
        this.subCategoryId = <any>this.route.snapshot.queryParamMap.get('subCategoryId');
        this.categoryName = <any>this.route.snapshot.queryParamMap.get('categoryName');
        const items = document.querySelectorAll(".list-group-item");
        items.forEach(item => {
            item.addEventListener("click", () => {
                items.forEach(i => i.classList.remove("active-category"));
                item.classList.add("active-category");
            });
        });
        this.brands = await this.getAllBrandsForMainCategory(this.mainCategoryId);
        this.cdr.detectChanges();

        setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 100);

    }

    async getMainCategory() {
        if (this.mainCategoryId) {
            this.mainCategory = <any>await this.mainCategoriesService.getById(this.mainCategoryId);
            await this.loadSubCategory(this.mainCategoryId);
        }
    }

    async loadSubCategory(mainCategoriesIds: string) {
        this.loading = true;
        this.subCategories = [];
        let subCategoryId = <any>this.route.snapshot.queryParamMap.get('subCategoryId');
        if (!subCategoryId) this.subCategoryId = '';
        let query = <IQueryFormat>{
            find: <ISubCategories_P>{
                active: true,
                ssc_main_category_id: <any>{ $in: [ mainCategoriesIds ] }
            },
            select: <ISubCategories_S>{
                ssc_img_url__arr: 1,
                ssc_name_str: 1,
                ssc_order_num: 1,
                ssc_main_category_id: 1,
            },
            sort: <ISubCategories_S>{ ssc_order_num: 1 }
        };
        this.subCategories = await this.subCategoriesService.query(query);
        this.subCategories.unshift(<any>{ _id: "ALL", ssc_name_str: 'ALL' });
        if (!this.subCategoryId) this.subCategoryId = <any>this.subCategories[0]?._id;
        //await this.loadCategories();
        this.loading = false;
        this.cd.detectChanges();
    }

    async getAllBrandsForMainCategory(mainCategoryId: string) {
        let resp = await this.loadBrandService.loadBrands({ mainCategoryId: mainCategoryId });
        if (resp.length === 0) return [ { _id: null, swb_name_str: "No Results Founds" } ];
        return resp;
    }

    async assignModels() {
        if (!this.selectedBrand?._id) {
            this.models = [];
            return;
        }
        this.models = await this.modelService.query({
            find: <IModel_P>{
                swm_brand_id: this.selectedBrand._id,
            }
        });
    }

    async selectBrand(brand: any) {
        this.selectedBrand = brand;
        this.selectedModel = null;
        await this.assignModels();
        this.brandAccordionOpen = false;  // Collapse brand accordion
        this.modelAccordionOpen = true;   // Auto-open model accordion
        this.cd.detectChanges();
    }

    async selectModel(model: IModelOptions) {
        this.selectedModel = model;
        this.cd.detectChanges();
        this.selectedBrandModelService.set({
            brandId: this.selectedBrand._id,
            modelId: model._id,
            modelName: model.swm_name_str
        });

        // modelSelectionGuard sends shoppers here from wherever they were headed; now that a
        // model exists, drop them back on that page instead of the generic catalog.
        // only same-site paths, so a crafted ?returnUrl= can't bounce the shopper off-site
        const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
        if (returnUrl && returnUrl.startsWith('/') && !returnUrl.startsWith('//')) {
            await this.router.navigateByUrl(returnUrl);
            return;
        }

        await this.router.navigate([ '/phone-cases' ], {
            queryParams: {
                mainCategoryId: this.mainCategoryId,
                subCategoryId: this.subCategoryId,
                categoryName: this.categoryName || undefined,
                brandId: this.selectedBrand._id,
                modelId: model._id,
                modelName: model.swm_name_str
            }
        });
    }

    toggleBrandAccordion() {
        this.brandAccordionOpen = !this.brandAccordionOpen;
    }

    toggleModelAccordion() {
        this.modelAccordionOpen = !this.modelAccordionOpen;
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}

interface IBrandsOptions {
    _id: string;
    swb_name_str: string;
}

interface IModelOptions {
    _id: string;
    swm_name_str: string;
}
